import { Box, Group, Text } from "@repo/ui/core";
import { motion } from "framer-motion";
import classes from "@styles/onsite.module.css";

const SECTION_NUMBER_COLORS: Record<string, string> = {
  "01": "var(--mantine-color-emerald-4)",
  "02": "var(--mantine-color-blue-4)",
  "03": "var(--mantine-color-violet-4)",
  "04": "var(--mantine-color-orange-4)",
};

type Props = {
  number: string;
  title: string;
};

export function SectionDivider({ number, title }: Props) {
  const numberColor = SECTION_NUMBER_COLORS[number] ?? "var(--customer-accent)";

  return (
    <Box py={120}>
      <Group gap="xl" justify="center" align="baseline">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Text
            size="clamp(80px, 12vw, 160px)"
            fw={900}
            lh={1}
            className={classes.agendaNumber}
            style={{
              fontFamily: "Geist Sans, sans-serif",
              letterSpacing: "-0.04em",
              color: numberColor,
            }}
          >
            {number}
          </Text>
        </motion.div>
        <motion.div
          initial={{ opacity: 0, x: 30 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5, delay: 0.15 }}
        >
          <Text
            size="clamp(36px, 6vw, 80px)"
            fw={800}
            tt="uppercase"
            lh={1}
            style={{
              letterSpacing: "0.08em",
              color: "var(--mantine-color-gray-1)",
            }}
          >
            {title}
          </Text>
        </motion.div>
      </Group>
    </Box>
  );
}
